// extracted by mini-css-extract-plugin
export var btn = "CloseButton-module--btn--78303";